// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12511"][{"9433":0}[chunkId]] || "1.12515") + "/" + chunkId + ".js";
};